<script lang="ts">
  import { createEventDispatcher, getContext, onMount } from 'svelte';

  import { GAME_TYPE } from '@/comps-sdk/constants';
  import { EActCommonReceive, ECommon, type IActCommonReceive, type IZoneRoleSelect } from '@/comps-sdk/interface';
  import { actAuthCheck } from '@/comps-sdk/modules/auth';
  import { getMainUserInfo } from '@/comps-sdk/modules/user';
  import { authCheck, handleGoToAuth } from '@/comps-sdk/utils/auth-permission';
  import { isGameMsdk } from '@/comps-sdk/utils/platform';

  import type { IAMSPrePluginOption } from './type';

  export let data: IAMSPrePluginOption = {
    gameId: '',
    gameAppId: '',
    gameType: '',
    alias: '',
    qqAppid: '',
    wxAppid: '',
  };

  let { ZoneRoleSelect } = data;
  const { customAuthCheck } = data;

  if (!ZoneRoleSelect) {
    const context: any = getContext(EActCommonReceive.CONTEXT_INTERFACE_KEY) as IActCommonReceive.CompContextInterface;
    ZoneRoleSelect = context?.ZoneRoleSelect;
  }

  if (!ZoneRoleSelect) {
    throw new Error('没有区服选择组件，请先设置');
  }

  const dispatch = createEventDispatcher();

  // 游戏授权检查
  const doAuthCheck = async () => {
    const { gameId = '', gameAppId = '', qqAppid, wxAppid, scene, gameType, alias = '' } = data;

    console.log('customAuthCheck', customAuthCheck);
    if (customAuthCheck) {
      if (!gameId) {
        throw new Error('区服组件未接收到游戏id');
      }
      return await customAuthCheck({ gameId });
    }

    // 活动授权
    if (scene === ECommon.Scene.ACT) {
      if (!gameAppId && gameType === GAME_TYPE.mobile) {
        throw new Error('中台区服组件未接收到手游appid');
      }

      if (!alias && gameType === GAME_TYPE.client) {
        throw new Error('中台区服组件未接收到端游别名alias');
      }

      const isAuth = await actAuthCheck({
        gameId,
        authInfo: {
          type: 2,
          game_data: {
            detail: {
              type: Number(gameType),
              mobile_game: {
                qq_appid: qqAppid,
                wx_appid: wxAppid,
              },
              client_game: {
                alias,
              },
            },
          },
        },
      });

      return isAuth;
    }

    // 爱玩场景授权
    if (scene === ECommon.Scene.IWAN) {
      if (!gameId) {
        throw new Error('爱玩场景区服组件未接收到游戏id');
      }

      const isAuth = await authCheck({ gameId });
      if (!isAuth) {
        handleGoToAuth({ gameId });
      }
      return isAuth;
    }

    // 其他情况默认返回 true
    return true;
  };

  const initZoneRoleSelect = async () => {
    const { gameId = '', gameAppId = '', scene, gameType, alias, isNeedHonorBind } = data;
    const isAuth = await doAuthCheck();

    if (!isAuth) {
      return false;
    }

    const getPropertyImg = () => {
      try {
        const { propertyData } = data;
        const { instanceInfo } = propertyData || {};
        const { pic_url: img } = instanceInfo;
        return img;
      } catch (err) {
        console.error('获取礼包图片失败: ', err);
        return '';
      }
    };

    // 拉起区服
    const zone = ZoneRoleSelect!({
      scene,
      gameId,
      gameAppId: `${gameAppId}`,
      gameType,
      alias,
      btnText: '领取礼包',
      isNeedHonorBind,
      honorBindConfig: {
        failedImg: getPropertyImg(),
        bindSource: 'iwan_active_honor',
        isNeedHonorBind,
      },

      getUserInfoCb: async () => {
        // 用于显示用户信息头像，选填
        if (isGameMsdk()) {
          return null;
        }

        const userInfo = await getMainUserInfo();
        const { code, result } = userInfo;
        if (code !== 0) {
          return {
            type: '',
            nickname: '',
            headImgUrl: '',
          };
        }

        return result;
      },

      confirmCb: (data) => {
        dispatch('confirm', data);
      },

      closeCb: () => {
        dispatch('close');
      },
    });

    // 确认成功事件
    zone?.$on?.('confirm', (event) => {
      // confirm 一定有结果
      dispatch('confirm', event!.detail as IZoneRoleSelect.ZoneRoleResult);
    });
  };

  onMount(() => {
    initZoneRoleSelect();
  });
</script>

<div />
